import { render, staticRenderFns } from "./ProductForm.vue?vue&type=template&id=55ab42ae&scoped=true&lang=html"
import script from "./ProductForm.vue?vue&type=script&lang=js"
export * from "./ProductForm.vue?vue&type=script&lang=js"
import style0 from "./ProductForm.vue?vue&type=style&index=0&id=55ab42ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ab42ae",
  null
  
)

export default component.exports